var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"custom-order-details"},[_c('div',{staticClass:"row"},[_c('p',{staticStyle:{"white-space":"pre"},attrs:{"data-test":"order-notes"}},[_vm._v(" "+_vm._s(_vm.$t(_vm.description))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }